import React from "react";
import styles from "./dashboard/Styles";
import {
  GET_ONE,
  GET_LIST,
  UPDATE,
  SimpleForm,
  FunctionField,
  Responsive,
  SaveButton,
  showNotification
} from "react-admin";
import { connect } from "react-redux";
import { change, submit } from "redux-form";
import moment from "moment";
import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";
import dataProviderFactory from "../dataProvider";

import {
  Card,
  Select,
  MenuItem,
  InputLabel,
  TextField,
  FormControlLabel,
  Switch,
  CardContent,
  Typography,
  LinearProgress,
  Checkbox,
  Grid,
} from "@material-ui/core";

import {
  map,
  length,
  head,
  filter,
  prop,
  propEq,
  find,
  isNil,
  path
} from "ramda";
import { isNull } from "util";
import { DATEFORMAT } from "../date-config";
import { getPermissionRole } from "../util";
import {
  applyLowSeasonDiscountFor,
  buildRentalPromoSnapshot,
  RENTAL_TIME_OPTIONS,
} from "../util/rentalPromo";
import { RentalPromoBadges } from "./RentalPromoBadges";
import {
  normalizeInsuranceId,
  resolveBookingInsuranceId,
  isPaidInsurance,
  resolveApplicableInsuranceId,
  insuranceLabel,
  insuranceSelectChoices,
  dailyInsurancePriceFromList,
  INSURANCE_REGULAR,
} from "../util/rentalInsurance";

const StyledSelect = styled(Select)`
  width: 256px !important;
`;

const StyledSpan = styled.div`
  color: red;
  padding: 10px;
  width: 100% !important;
`;

class ProcessRental extends React.Component {
  state = {
    clientRewards: 0, ocultarInput: false,
    isOnSubmit: false,
    discount: 0,
    driver_id: 0,
    comments: "",
    imt_comment: "",
    extra_comments: "",
    chargeTypeId: "2",
    location_id_1: 0,
    location_id_2: 0,
    time_1: 0,
    time_2: 0,
    date_1: null,
    date_2: null,
    r_gps: false,
    r_gps_disabled: false,
    rewards: 0,
    r_insurance: false,
    r_insurance_id: INSURANCE_REGULAR,
    low_seat: false,
    vehicle_model_1: 0,
    vehicle_model_2: 0,
    vehicleId: 0,
    gpsDeviceId: 0,
    rental: null,
    error: false,
    rentalTotal: 0,
    customAnticipatedCharge: false,
    customAnticipatedChargeValue: 0,
    noConfirmationEmail: false, locationFees: null, insurancePrices: null,
    priceDate: null, validDiscount: true
  };

  async getGpsDevices() {
    const { location_id_1, location_id_2, date_1, date_2, rental } = this.state;
    const dataProvider = await dataProviderFactory("rest");
    const responseGps = await dataProvider(GET_LIST, "gps_devices", {
      filter: {
        rental_id: rental.id,
        rental_availability: true,
        location_id_1,
        location_id_2,
        date_1,
        date_2
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });
    return responseGps;
  }

  async locationFeePrices(date) {
    const dataProvider = await dataProviderFactory("rest");
    const lcFreePrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        for_price_item_id: "rental_location_fee",
        location_id_1: this.state.location_id_1,
        location_id_2: this.state.location_id_2,
        for_date: date,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });
    return lcFreePrices;
  }

  async getAvailableRewards(id) {
    const dataProvider = await dataProviderFactory("rest");
    const client = await dataProvider(GET_ONE, "clients", { id });
    const data = path(["data", "availableRewards"], client);
    return data;
  }

  async gpsPrices(date) {
    const dataProvider = await dataProviderFactory("rest");
    const gpsPrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "gps_device",
        for_date: date,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });
    return gpsPrices;
  }

  async insurancePrices(date) {
    const dataProvider = await dataProviderFactory("rest");
    const insurancePrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "insurance",
        for_date: date,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });
    return insurancePrices;
  }

  getVehicleModelPrices(modelPrices = [], days) {
    const matches = (modelPrices || []).filter(
      price =>
        Number(price.days_interval_1) <= days &&
        Number(price.days_interval_2) >= days
    );
    if (!matches.length) return 0;
    matches.sort((a, b) => {
      const da = a.start_date ? new Date(a.start_date).getTime() : 0;
      const db = b.start_date ? new Date(b.start_date).getTime() : 0;
      return db - da;
    });
    return prop("price", matches[0]) || 0;
  }

  async getModelPrices1(date) {
    return this.getModelPrices(this.state.vehicle_model_1, date);
  }

  async getModelPrices2(date) {
    return this.getModelPrices(this.state.vehicle_model_2, date);
  }

  async getModelPrices(model, date) {
    const dataProvider = await dataProviderFactory("rest");
    const modelPrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        prices_vehicle_model_id: model,
        for_date: date,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });
    return modelPrices;
  }

  async getHolidays1() {
    const { location_id_1 } = this.state;
    return this.getHolidays(location_id_1);
  }

  async getHolidays2() {
    const { location_id_2 } = this.state;
    return this.getHolidays(location_id_2);
  }

  async getHolidays(locationId) {
    const { date_1, date_2 } = this.state;

    const dataProvider = await dataProviderFactory("rest");
    const holidays = dataProvider(GET_LIST, "holidays", {
      filter: {
        startDate: date_1,
        endDate: date_2,
        location_id: locationId
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    return holidays;
  }

  async getVehicles() {
    const {
      rental,
      vehicle_model_1,
      location_id_1,
      location_id_2,
      date_1,
      date_2,
      time_2
    } = this.state;
    const dataProvider = await dataProviderFactory("rest");
    const responseVehicles = await dataProvider(GET_LIST, "vehicles", {
      filter: {
        rental_availability: true,
        rental_id: rental.id,
        vehicle_model_id: vehicle_model_1,
        vehicle_status_id: 1,
        location_id_1,
        location_id_2,
        date_1,
        date_2,
        time_2
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });
    return responseVehicles;
  }

  async fetchData() {
    const { id } = this.props.match.params;
    const dataProvider = await dataProviderFactory("rest");
    const responseRental = await dataProvider(GET_ONE, `pending_rentals`, {
      id
    });

    const vehicleModels = await dataProvider(GET_LIST, "vehicle_models", {
      filter: { active: true, type: "2_1" },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });

    const responseLocations = await dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    const sameDay = this.isOnSameDay(responseRental.data.date_1, responseRental.data.date_2);

    this.setState(
      {
        driver_id: responseRental.data.driver.id,
        rewards: responseRental.data.booking.rewards,
        vehicle_model_1: responseRental.data.booking.vehicle_model_1,
        vehicle_model_2: responseRental.data.booking.vehicle_model_2,
        location_id_1: responseRental.data.location_id_1,
        location_id_2: responseRental.data.location_id_2,
        date_1: responseRental.data.date_1,
        date_2: responseRental.data.date_2,
        time_1: sameDay ? "10:00:00" : responseRental.data.time_1,
        time_2: sameDay ? "18:00:00" : responseRental.data.time_2,
        low_seat: responseRental.low_seat,
        r_gps: responseRental.data.booking.r_gps,
        r_insurance_id: resolveBookingInsuranceId(responseRental.data.booking),
        r_insurance: isPaidInsurance(
          resolveBookingInsuranceId(responseRental.data.booking)
        ),
        rental: responseRental.data,
        locations: responseLocations.data,
        models: vehicleModels.data,
        priceDate: responseRental.data.booking.price_date,
      },

      async () => {
        const { priceDate } = this.state;

        const [
          vehicles,
          gpsDevices,
          modelPrices1,
          modelPrices2,
          gpsPrices,
          locationFees,
          insurancePrices,
          hollidays1,
          hollidays2,
          clientRewards
        ] = await Promise.all([
          this.getVehicles(),
          this.getGpsDevices(),
          this.getModelPrices1(priceDate),
          this.getModelPrices2(priceDate),
          this.gpsPrices(priceDate),
          this.locationFeePrices(priceDate),
          this.insurancePrices(priceDate),
          this.getHolidays1(),
          this.getHolidays2(),
          this.getAvailableRewards(responseRental.data.driver.id)
        ]);
        this.setState({
          r_gps_disabled: this.getModelName1() === "K1600GT",
          vehicles: vehicles.data,
          gpsDevices: gpsDevices.data,
          modelPrices1: modelPrices1.data,
          modelPrices2: modelPrices2.data,
          gpsPrices: gpsPrices.data,
          locationFees: locationFees.data,
          insurancePrices: insurancePrices.data,
          hollidays1: hollidays1.data,
          hollidays2: hollidays2.data,
          clientRewards,
        }, () => this.getItemsPrices());
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (null === this.state.rental) {
      this.fetchData()
    }

    if (prevState.discount !== this.state.discount ||
      prevState.rewards !== this.state.rewards) {
      this.getItemsPrices()
    }

    if (prevState.date_1 !== this.state.date_1) {
      this.getItemsPrices()
    }

    if (prevState.time_1 !== this.state.time_1) {
      this.getItemsPrices()
    }

    if (prevState.date_2 !== this.state.date_2) {
      this.getItemsPrices()
    }

    if (prevState.time_2 !== this.state.time_2) {
      this.getItemsPrices()
    }

    if (prevState.r_gps !== this.state.r_gps) {
      this.getItemsPrices()
    }

    if (
      prevState.r_insurance !== this.state.r_insurance ||
      prevState.r_insurance_id !== this.state.r_insurance_id
    ) {
      this.getItemsPrices()
    }

    if (prevState.location_id_1 !== this.state.location_id_1) {
      this.getItemsPrices()
    }
  }

  componentDidMount() {
    this.fetchData()
  }

  getStripeType(rental) {
    return rental.location_1.location_name === "Lisbon"
      ? "rentals_pt"
      : "rentals";
  }

  isUserStripe = rental => {
    let stripToUse = null;
    if (!isNil(rental)) {
      if (!rental.from_agency) {
        const stripeType = this.getStripeType(rental);
        stripToUse = prop(`stripe_${stripeType}`, rental.driver);
      }
    }
    return !isNil(stripToUse);
  };

  duration = (date1, time1, date2, time2) => {
    const days = moment(date2).diff(date1, "days");
    if (time1 === "10:00:00" && time2 === "18:00:00") {
      return days + 1;
    } else if (time1 === "18:00:00" && time2 === "10:00:00") {
      return days - 1;
    }
    return days || 0;
  };

  isOnSameDay = (date_1, date_2) => {
    return moment(date_1).isSame(date_2, 'day');
  };

  getModelName = modelId => {
    const { models } = this.state;
    return prop("model_name", find(propEq("id", modelId), models));
  };

  getModelName1() {
    const { models, vehicle_model_1 } = this.state;
    const selectedModel = head(filter(propEq("id", vehicle_model_1), models));
    return selectedModel.model_name;
  }

  handleCheckChange = event => {
    this.setState({
      [event.target.name]: event.target.checked
    });

    if (event.target.name === "r_gps") {
      this.setState({
        gpsDeviceId: 0
      });
    }
    
    if (event.target.name === 'customAnticipatedCharge') {  
      let dayActual = moment(Date.now()).format("YYYY-MM-DD")
      if (moment(this.state.date_1).diff(dayActual, "days") <= 30) {
        if (event.target.checked) {
          this.setState({ customAnticipatedChargeValue: (this.state.rentalTotal*0.3).toFixed(2) });
        } 
        else{this.setState({ customAnticipatedChargeValue: this.state.rentalTotal });}
      } else{
        if (!event.target.checked) {
          this.setState({ customAnticipatedChargeValue: (this.state.rentalTotal*0.3).toFixed(2) });
        } 
        else{this.setState({ customAnticipatedChargeValue: this.state.rentalTotal });}
      }
    }
  };

  handleChange = (element, type) => {

    if (element.target.id === "date_1") {
      const newDate2 = moment(element.target.value).add(1, 'day').format("YYYY-MM-DD")
      //const date2 = document.getElementById('date_2')
      //date2.min = element.target.value
      //date2.value = newDate2
      this.setState({ date_1: newDate2 })
    }
    if (element.target.id === "date_2") {
      const newDate2 = moment(element.target.value).add(1, 'day').format("YYYY-MM-DD")
      this.setState({ date_2: newDate2 })
    }

    this.setState({ [type]: element.target.value }, async () => {
      const { priceDate } = this.state;

      const [
        updatedVehicles,
        updatedGps,
        updatedLocationFees,
        updatedHollidays1,
        updatedHollidays2
      ] = await Promise.all([
        this.getVehicles(),
        this.getGpsDevices(),
        this.locationFeePrices(priceDate),
        this.insurancePrices(priceDate),
        this.getHolidays1(),
        this.getHolidays2()
      ]);

      const { date_1, date_2, r_insurance_id } = this.state;
      let { time_1, time_2 } = this.state;

      // If it's a rental that starts and ends on the same day force morning pickup and evening dropoff
      const sameDay = this.isOnSameDay(date_1, date_2)
      time_1 = sameDay ? "10:00:00" : time_1;
      time_2 = sameDay ? "18:00:00" : time_2;

      // Si cambian días, Basic/Premium caen a Regular si no cumplen mínimo
      const promo = buildRentalPromoSnapshot({
        date_1,
        time_1,
        date_2,
        time_2,
        from_agency: path(["from_agency"], this.state.rental),
      })
      const nextInsId = resolveApplicableInsuranceId(
        r_insurance_id,
        promo.extras_days
      )
    
      this.setState({
        rentalDays: promo.moto_days,
        occupancyDays: promo.extras_days,
        isWeekendPromo: promo.is_weekend,
        lowSeasonPct: promo.low_season_pct,
        r_insurance_id: nextInsId,
        r_insurance: isPaidInsurance(nextInsId),
        vehicleId: 0,
        gpsDeviceId: 0,
        vehicles: updatedVehicles.data,
        gpsDevices: updatedGps.data,
        locationFees: updatedLocationFees.data,
        hollidays1: updatedHollidays1.data,
        hollidays2: updatedHollidays2.data,
        time_1: time_1,
        time_2: time_2,
      }, () => this.getItemsPrices());
    });
  };

  handlePriceDateChange = (event) => {
    const newPriceDate = event.target.value;
    this.setState({ priceDate: newPriceDate }, async () => {
      const [
        modelPrices1,
        modelPrices2,
        gpsPrices,
        locationFees,
        insurancePrices,
      ] = await Promise.all([
        this.getModelPrices1(newPriceDate),
        this.getModelPrices2(newPriceDate),
        this.gpsPrices(newPriceDate),
        this.locationFeePrices(newPriceDate),
        this.insurancePrices(newPriceDate),
      ]);

      this.setState({
        modelPrices1: modelPrices1.data,
        modelPrices2: modelPrices2.data,
        gpsPrices: gpsPrices.data,
        locationFees: locationFees.data,
        insurancePrices: insurancePrices.data,
      }, () => this.getItemsPrices());
    });
  };

  rewardsNotOk = () => {
    return parseInt(this.state.rewards, 0) > parseInt(this.state.clientRewards, 0);
  };

  handleSaveClick = () => {
    const { submit } = this.props;
    this.setState({ isOnSubmit: true }, () => {
      submit("process-rental");
    });
  };

  handleSubmit = async () => {
    const {
      discount,
      rental,
      vehicleId,
      date_1,
      date_2,
      time_1,
      time_2,
      extra_comments,
      imt_comment,
      location_id_1,
      location_id_2,
      chargeTypeId,
      comments,
      gpsDeviceId,
      r_gps, low_seat,
      r_insurance_id,
      vehicle_model_1,
      rewards,
      customAnticipatedCharge,
      noConfirmationEmail,
      priceDate,
    } = this.state;
    // Recalc con date/time actuales (si el booking nació sin weekend y luego se cambió la hora)
    const priced = this.getItemsPrices() || {}
    const rentalTotal = priced.rentalTotal1 != null
      ? priced.rentalTotal1
      : this.state.rentalTotal
    let totalCharge = 0

    let dayActual = moment(Date.now()).format("YYYY-MM-DD")
    if (moment(date_1).diff(dayActual, "days") <= 30) {
      if(customAnticipatedCharge){
        totalCharge = (rentalTotal*0.3).toFixed(2);
      } 
      else{
        totalCharge = (rentalTotal).toFixed(2);
      }
    } else{
      if (!customAnticipatedCharge) {
        totalCharge = (rentalTotal*0.3).toFixed(2);
      } 
      else{ totalCharge = (rentalTotal).toFixed(2); }
    } 
    const bodyRequest = {
      id: rental.id,
      data: {
        driver_id: rental.client_id,
        discount,
        vehicle_id: vehicleId,
        date_1,
        date_2,
        time_1,
        time_2,
        location_id_1,
        location_id_2,
        charge_type_id: chargeTypeId,
        comments,
        imt_comment,
        extra_comments,
        gpsdevice_id: gpsDeviceId,
        r_gps: this.getModelName1() === "K1600GT" ? true : r_gps, 
        low_seat,
        r_insurance_id: normalizeInsuranceId(r_insurance_id),
        r_insurance: isPaidInsurance(r_insurance_id),
        vehicle_model_1,
        rewards,
        rentalTotal,
        customAnticipatedCharge,
        customAnticipatedChargeValue: totalCharge,
        noConfirmationEmail,
        priceDate,
      }
    };

    const dataProvider = await dataProviderFactory("rest");
    dataProvider(UPDATE, "pending_rentals", bodyRequest)
      .then(() => {
        this.setState({
          availableItems: {},
          data: {},
          events: {},
          newItem: 0
        });
        const { history } = this.props;
        history.replace("/pending_rentals");
      })
      .catch(error => {
        this.setState({ isOnSubmit: false });
        this.props.showNotification(error.message, "error");
      });
  };

  isWeekEnd = curDay => {
    const date1 = moment(curDay);
    return date1.weekday() === 6 || date1.weekday() === 0;
  };

  isHoliday = (curDay, items) => {
    const hasHollidays = [];
    map(hd => {
      const date1 = moment(hd.date).format("YYYY-MM-DD");
      const date2 = curDay.format("YYYY-MM-DD");
      if (date1 === date2 || curDay.weekday() === 6 || curDay.weekday() === 7) {
        hasHollidays.push(hd);
      }
    }, items || []);
    return length(hasHollidays) > 0;
  };

  handleChangeItem = (element, type) => {
    if (type === 'customAnticipatedChargeValue') {
      this.setState({ rentalTotal: element.target.value });
      this.setState({ customAnticipatedChargeValue: element.target.value });
    }
    if (type === 'discount') {
      let descunento = element.target.value
      let valueToPay = this.state.customAnticipatedChargeValue
      let result = valueToPay - descunento 
      //console.log(result)
      if(result < 0)
      {
        this.setState({ validDiscount: false}); 
      } 
    }
    this.setState({ [type]: element.target.value });
  };

  handelModelChange = element => {
    this.setState(
      {
        vehicle_model_1: element.target.value,
        vehicles: [],
        modelPrices1: [],
        modelPrices2: [],
        vehicleId: 0
      },
      async () => {
        const { priceDate } = this.state;
        const updatedVehicles = await this.getVehicles();
        const updatedModelPrices1 = await this.getModelPrices1(priceDate);
        const updatedModelPrices2 = await this.getModelPrices2(priceDate);
        const updatedLocationFees = await this.locationFeePrices(priceDate);
        
        this.setState({
          r_gps_disabled: this.getModelName1() === "K1600GT",
          vehicles: updatedVehicles.data,
          modelPrices1: updatedModelPrices1.data,
          locationFees: updatedLocationFees.data,
          modelPrices2: updatedModelPrices2.data
        }, async () => this.getItemsPrices());
      }
    );
  };

  validateDates = () => {
    const { date_1, date_2 } = this.state;
    const d2 = moment(date_2);
    const d1 = moment(date_1);
    return d2.isAfter(d1) || d1.isSame(d2, 'day');
  };

  chargeTypeId = rental => {
    const chargeTypes = [
      { _id: "1", description: "Stripe" },
      { _id: "2", description: "Other (Money, bank transfer)" }
    ];
    return (
      <div>
        <InputLabel htmlFor="charge-simple">Charge Type</InputLabel> <br />
        <StyledSelect
          onChange={e => this.handleChangeItem(e, "chargeTypeId")}
          inputProps={{
            name: "charge",
            id: "charge-simple"
          }}
          value={this.state.chargeTypeId}
          disabled={!this.isUserStripe(rental) || rental.from_agency}
        >
          {map(item => {
            return (
              <MenuItem key={item._id} value={item._id}>
                {item.description}
              </MenuItem>
            );
          }, chargeTypes)}
        </StyledSelect>
        <br />
      </div>
    );
  };

  getItemsPrices = () => {
    const {
      rental, customAnticipatedCharge,
      modelPrices1,
      modelPrices2,
      date_1,
      date_2,
      time_1,
      rewards,
      time_2,
      gpsPrices = [],
      locationFees,
      insurancePrices = [],
      location_id_1,
      location_id_2,
      r_insurance_id,
      r_gps,
      discount, priceDate
    } = this.state

    let model1Price = 0;
    let model2Price = 0;
    let gpsPrice = 0;
    let locationFee = 0;
    let rentalTotal1 = 0;
    let rentalTotal2 = 0;
    let vipInsurancePrice = 0;

    let rentalDays = this.duration(date_1, time_1, date_2, time_2);
    const promo = buildRentalPromoSnapshot({
      date_1,
      time_1,
      date_2,
      time_2,
      from_agency: path(["from_agency"], this.state.rental),
    });
    const motoDays = promo.moto_days;
    const extrasDays = promo.extras_days;
    const applicableInsId = resolveApplicableInsuranceId(
      r_insurance_id,
      extrasDays
    );

    if (rentalDays > 0 && !isNil(rentalDays)) {
      model1Price = this.getVehicleModelPrices(modelPrices1, motoDays);
      model2Price = this.getVehicleModelPrices(modelPrices2, motoDays);
       
      if(r_gps && this.getModelName1() !== "K1600GT"){        
        if(gpsPrices[0] !== undefined)
        { 
          gpsPrice = gpsPrices[0].price
        }
      } else {
        gpsPrice = 0
      }

      vipInsurancePrice = dailyInsurancePriceFromList(
        insurancePrices,
        applicableInsId
      );
      

      let locationFeePrice = 0
      if(locationFees != null){
        locationFeePrice = location_id_1 !== location_id_2 ? prop("price", head(locationFees)) : 0;
      }
     

      const moto1Total = applyLowSeasonDiscountFor(model1Price * motoDays, promo, "moto");
      const moto2Total = applyLowSeasonDiscountFor(model2Price * motoDays, promo, "moto");
      const gpsTotal = applyLowSeasonDiscountFor(gpsPrice * extrasDays, promo, "gps");
      const vipTotal = applyLowSeasonDiscountFor(
        vipInsurancePrice * extrasDays,
        promo,
        "vip"
      );
      const oneWayTotal = applyLowSeasonDiscountFor(locationFeePrice, promo, "one_way");

      rentalTotal1 = moto1Total + gpsTotal + vipTotal + oneWayTotal;
      rentalTotal2 = moto2Total + gpsTotal + vipTotal + oneWayTotal;
    }

    let dayActual = moment(Date.now()).format("YYYY-MM-DD")
    let dayDifern = moment(date_1).diff(dayActual, "days")
    let customAnticipatedChargeValue0 = rentalTotal1

    if (moment(date_1).diff(dayActual, "days") > 30) {
      if (customAnticipatedCharge == false) {
        customAnticipatedChargeValue0 = (((rentalTotal1) * 0.3)).toFixed(2)
      }
    }

    this.setState({
      model1Price,
      model2Price,
      gpsPrice,
      locationFees,
      rentalTotal1,
      rentalTotal2,
      vipInsurancePrice,
      rentalDays: motoDays,
      occupancyDays: extrasDays,
      isWeekendPromo: promo.is_weekend,
      lowSeasonPct: promo.low_season_pct,
      rentalTotal: rentalTotal1,
      customAnticipatedChargeValue: customAnticipatedChargeValue0
    })
    // Retorno sync: handleSubmit no debe usar rentalTotal stale (booking sin weekend → cambio hora → process)
    return {
      rentalTotal1,
      rentalTotal2,
      motoDays,
      extrasDays,
      isWeekendPromo: promo.is_weekend,
    }
  }

  checkOneDay = (bike) => {
    let nextDay = new Date(Date.parse(bike.date_2));
    nextDay.setDate(nextDay.getDate() + 1);
    if (nextDay.toISOString().slice(0, 10) === this.state.date_1) {
      return true
    } else {
      return false
    }
  }

  render() {
    if (isNil(this.state.rental) || isNil(this.state.vehicles)) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    const {
      rental,
      models,
      locations,
      vehicles,
      gpsDevices,
      date_1,
      date_2,
      hollidays1,
      hollidays2,
      isOnSubmit,
      priceDate,
      model1Price,
      model2Price,
      gpsPrice, r_gps,
      locationFees,
      rentalTotal1,
      rentalTotal2,
      vipInsurancePrice,
      rentalDays,
      rentalTotal,  location_id_1,
      location_id_2,
      customAnticipatedCharge,
      customAnticipatedChargeValue
    } = this.state;

    let dayActual = moment(Date.now()).format("YYYY-MM-DD")
    let locationFeePrice = location_id_1 !== location_id_2 ? prop("price", head(locationFees)) : 0;
    let valueConfirm = customAnticipatedChargeValue
    if (moment(date_1).diff(dayActual, "days") <= 30) {
      if (customAnticipatedCharge == true) {
        let toCharge = parseFloat(((rentalTotal) * 0.3))
        valueConfirm = ( toCharge ).toFixed(2)
      }
    }
    else{
      if (customAnticipatedCharge == true) {
        valueConfirm = (rentalTotal - this.state.rewards - this.state.discount).toFixed(2)
      }
    } 
    return (
      <Card>
        <CardContent>
          <Typography
            gutterBottom
            variant="display3"
            component="h2"
            style={styles.cardHeaderStyle}
          >
            Processing motorcycle Rental For:{" "}
            <b>
              {rental.booking.r_first_name} {rental.booking.r_last_name}
            </b>
          </Typography>
          <br />
          <Responsive
            medium={
              <div>
                <div style={styles.flex}>
                  <div style={styles.leftColB}>
                    <div style={styles.flexB}>
                      <SimpleForm
                        style={{ width: "100%" }}
                        form="process-rental"
                        onSubmit={this.handleSubmit}
                        toolbar={null}
                      >
                        <InputLabel shrink htmlFor="l1-simple">
                          Pick Up Location
                        </InputLabel>
                        <StyledSelect
                          onChange={e => this.handleChange(e, "location_id_1")}
                          inputProps={{
                            name: "l1",
                            id: "l1-simple"
                          }}
                          value={this.state.location_id_1}
                        >
                          {map(item => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.location_name}
                              </MenuItem>
                            );
                          }, locations)}
                        </StyledSelect>
                        <br />
                        <TextField
                          id="date_1"
                          label="Pick Up Date"
                          type="date"
                          onChange={e => this.handleChange(e, "date_1")}
                          defaultValue={moment(rental.date_1).format(
                            "YYYY-MM-DD"
                          )}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                        {this.state.date_1 === "" && (
                          <StyledSpan>* Please select Pick-up date</StyledSpan>
                        )}
                        <br />
                        <InputLabel shrink htmlFor="time_1-simple">
                          Pick Up Time
                        </InputLabel>
                        <StyledSelect
                          disabled={this.isOnSameDay(date_1, date_2)}
                          onChange={e => this.handleChange(e, "time_1")}
                          inputProps={{
                            name: "time_1",
                            id: "time_1-simple"
                          }}
                          value={this.state.time_1}
                        >
                          {map(
                            item => {
                              return (
                                <MenuItem value={item.id} key={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            },
                            [
                              ...RENTAL_TIME_OPTIONS
                            ]
                          )}
                        </StyledSelect>

                        <br />
                        <InputLabel shrink htmlFor="l1-simple">
                          Drop Off Location
                        </InputLabel>
                        <StyledSelect
                          onChange={e => this.handleChange(e, "location_id_2")}
                          inputProps={{
                            name: "l1",
                            id: "l1-simple"
                          }}
                          value={this.state.location_id_2}
                        >
                          {map(item => {
                            return (
                              <MenuItem value={item.id} key={item.id}>
                                {item.location_name}
                              </MenuItem>
                            );
                          }, locations)}
                        </StyledSelect>
                        <br />
                        <TextField
                          id="date_2"
                          label="Drop-Off Date"
                          type="date"
                          onChange={e => this.handleChange(e, "date_2")}
                          defaultValue={moment(rental.date_2).format(
                            "YYYY-MM-DD"
                          )}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />

                        {this.state.date_2 === "" && (
                          <StyledSpan>* Please select Drop-off date</StyledSpan>
                        )}

                        {!this.validateDates() && (
                          <StyledSpan>
                            Drop-off date should be after Pick-up date
                          </StyledSpan>
                        )}

                        <br />
                        <InputLabel shrink htmlFor="time_2-simple">
                          Drop Off Time
                        </InputLabel>
                        <StyledSelect
                          disabled={this.isOnSameDay(date_1, date_2)}
                          onChange={e => this.handleChange(e, "time_2")}
                          inputProps={{
                            name: "time_2",
                            id: "time_2-simple"
                          }}
                          value={this.state.time_2}
                        >
                          {map(
                            item => {
                              return (
                                <MenuItem value={item.id} key={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            },
                            [
                              ...RENTAL_TIME_OPTIONS
                            ]
                          )}
                        </StyledSelect>
                        <br />
                        <TextField
                          id="priceDate"
                          label="Applicable Price Date"
                          type="date"
                          onChange={e => this.handlePriceDateChange(e)}
                          defaultValue={moment.utc(priceDate).format(
                            "YYYY-MM-DD"
                          )}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                        <br />
                        <FormControlLabel
                          control={
                            <Switch
                              name="r_gps"
                              id="r_gps"
                              checked={this.state.r_gps}
                              onChange={e => this.handleCheckChange(e)}
                              /*value="0"*/
                              color="primary"
                              disabled={this.state.r_gps_disabled}
                            />
                          }
                          label="GPS"
                        />
                        <InputLabel htmlFor="r_insurance_id">Insurance</InputLabel>
                        <StyledSelect
                          name="r_insurance_id"
                          id="r_insurance_id"
                          value={this.state.r_insurance_id}
                          onChange={e => {
                            const id = normalizeInsuranceId(e.target.value);
                            this.setState(
                              {
                                r_insurance_id: id,
                                r_insurance: isPaidInsurance(id),
                              },
                              () => this.getItemsPrices()
                            );
                          }}
                        >
                          {insuranceSelectChoices(
                            this.state.occupancyDays != null
                              ? this.state.occupancyDays
                              : rentalDays
                          ).map(opt => (
                            <MenuItem
                              key={opt.id}
                              value={opt.id}
                              disabled={!!opt.disabled}
                            >
                              {opt.name}
                            </MenuItem>
                          ))}
                        </StyledSelect>
                        <FormControlLabel
                          control={
                            <Switch
                              name="low_seat"
                              id="low_seat"
                              checked={this.state.low_seat}
                              onChange={(e) => this.handleCheckChange(e)}
                              value="0"
                              color="primary"
                            />
                          }
                          label="Low Seat"
                        />
                        <br />
                        <InputLabel shrink htmlFor="model-simple">
                          Model
                        </InputLabel>
                        <StyledSelect
                          onChange={this.handelModelChange}
                          inputProps={{
                            name: "model",
                            id: "model-simple"
                          }}
                          value={this.state.vehicle_model_1}
                        >
                          {map(item => {
                            return (
                              <MenuItem value={item.id} key={item.id}>
                                {item.model_name}
                              </MenuItem>
                            );
                          }, models)}
                        </StyledSelect>
                        <br />
                        <InputLabel shrink htmlFor="bike-simple">
                          Motorcycle *
                        </InputLabel>
                        <StyledSelect id="vehicleId"
                          onChange={e => this.handleChangeItem(e, "vehicleId")}
                          inputProps={{
                            name: "bike",
                            id: "bike-simple"
                          }}
                          value={this.state.vehicleId}
                        >
                          {map(item => {
                            if (item.date_2.slice(0, 10) === date_1 || this.checkOneDay(item)) {
                              return (<MenuItem value={item.id} key={item.id}>
                                /!\** {item.licence_plate} {item.renting ? "®" : ""} ({item.vehicle_color} /{" "}
                                {item.vehicle_mileage} kms) **/!\
                              </MenuItem>)
                            } else {
                              return (<MenuItem value={item.id} key={item.id}>
                                {item.licence_plate} {item.renting ? "®" : ""} ({item.vehicle_color} /{" "}
                                {item.vehicle_mileage} kms)
                              </MenuItem>)
                            }
                          }, vehicles)}
                        </StyledSelect>
                        {this.state.vehicleId === 0 && (
                          <StyledSpan>* Please select Motorcycle</StyledSpan>
                        )}

                        <br />
                        {!this.state.r_gps_disabled && r_gps && (
                          <React.Fragment>
                            <InputLabel shrink htmlFor="gps-simple">
                              Gps Device *
                            </InputLabel>{" "}
                            <br />
                            <StyledSelect
                              onChange={e =>
                                this.handleChangeItem(e, "gpsDeviceId")
                              }
                              inputProps={{
                                name: "gps",
                                id: "gps-simple"
                              }}
                              value={this.state.gpsDeviceId}
                            >
                              {map(item => {
                                return (
                                  <MenuItem value={item.id} key={item.id}>
                                    {item.model}
                                  </MenuItem>
                                );
                              }, gpsDevices)}
                            </StyledSelect>
                            {this.state.gpsDeviceId === 0 &&
                              this.state.r_gps && (
                                <StyledSpan>
                                  * Please select GPS device
                                </StyledSpan>
                              )}
                          </React.Fragment>
                        )}
                        {moment(date_1).diff(dayActual, "days") <=
                          30 && (
                            <React.Fragment>
                              <InputLabel shrink htmlFor="rentalTotal">
                                Value to be charged <span style={styles.colorBlack}>€ {(valueConfirm - this.state.rewards - this.state.discount).toFixed(2) }</span> 
                              </InputLabel> 

                              {/* <TextField
                                id="customAnticipatedChargeValue"
                                name="customAnticipatedChargeValue"
                                type="number" disabled={true}
                                value={rentalTotal}
                                onChange={e => this.handleChangeItem(e, "customAnticipatedChargeValue")}
                              /> */}

                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="customAnticipatedCharge"
                                    checked={customAnticipatedCharge}
                                    onChange={e => this.handleCheckChange(e)}
                                    value="customAnticipatedCharge"
                                  />
                                }
                                label="Confirm 30% value to be charged!"
                              />
                              {this.state.customAnticipatedChargeValue > rentalTotal1  && (
                                  <StyledSpan>* Value to be charged is greater than rental cost First choice of motorcycle</StyledSpan>
                              )}
                              <p>Rental Value: {rentalTotal}{" "} €.</p>
                            </React.Fragment>
                          )}
                        {moment(date_1).diff(dayActual, "days") >
                          30 && (
                            <React.Fragment>
                              <InputLabel shrink htmlFor="rentalTotal">
                                Value to be charged <span  style={styles.colorBlack}>€ {valueConfirm}</span> 
                              </InputLabel> 
                             

                              {/* <TextField
                                id="customAnticipatedChargeValue"
                                name="customAnticipatedChargeValue"
                                type="number" disabled={true}
                                onChange={e => this.handleChangeItem(e, "customAnticipatedChargeValue")}
                                value={customAnticipatedChargeValue}
                                InputLabelProps={{
                                  style: {color: 'green'},
                                  shrink: true
                                }}
                              /> */}

                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="customAnticipatedCharge"
                                    checked={customAnticipatedCharge}
                                    value="customAnticipatedCharge"
                                    onChange={e => this.handleCheckChange(e)}
                                  />
                                }
                                label="Confirm 100% value to be charged!"
                              />
                              {this.state.customAnticipatedChargeValue > rentalTotal1  && (
                                  <StyledSpan>* Value to be charged is greater than rental cost First choice of motorcycle</StyledSpan>
                              )}
                              {!customAnticipatedCharge && (
                                  <p>
                                   30% of the total will be charged on save.
                                  </p>
                              )}
                              {customAnticipatedCharge && (
                                  <p>
                                   100% of the total will be charged on save.
                                  </p>
                              )}
                               <p>Rental Value: {rentalTotal}{" "} €.</p>
                            </React.Fragment>
                          )}
                        <br />
                        <p>
                          <b>Available Rewards: {this.state.clientRewards - this.state.rewards}</b>
                        </p>
                        <TextField
                          id="rewards"
                          label="Rewards requested to use"
                          type="number"
                          onChange={e => this.handleChangeItem(e, "rewards")}
                          value={this.state.rewards}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                        {this.rewardsNotOk() && (
                          <span
                            style={{
                              color: "red",
                              fontSize: "17px"
                            }}
                          >
                            <b>Requested rewards are not available!</b>
                          </span>
                        )}

                        <br />
                        <TextField
                          id="discount"
                          label="Discount"
                          type="number"
                          onChange={e => this.handleChangeItem(e, "discount")}
                          value={this.state.discount}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                        {this.state.discount > rentalTotal1  && (
                          <StyledSpan>* Discount cannot be greater than the rental cost</StyledSpan>
                        )}

                        <br />
                        {this.chargeTypeId(rental)}
                        <br />
                        <TextField
                          fullWidth
                          id="imt_comment" multiline
                          label="IMT Comments"
                          type="text"
                          onChange={e =>
                            this.handleChangeItem(e, "imt_comment")
                          }
                          value={this.state.imt_comment}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />

                        <br />
                        <TextField
                          fullWidth multiline
                          id="extra_comments"
                          label="Internal Comments"
                          type="text"
                          onChange={e =>
                            this.handleChangeItem(e, "extra_comments")
                          }
                          value={this.state.extra_comments}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      </SimpleForm>
                    </div>
                    <CardContent>
                      <Grid container spacing={24} alignItems="center">
                        <Grid item>
                          <SaveButton
                            onClick={this.handleSaveClick}
                            disabled={
                              (![1, 2, 3, 4, 5, 6, 9].includes(getPermissionRole())) ||
                              isOnSubmit ||
                              this.state.clientRewards < this.state.rewards ||
                              this.state.date_2 === "" ||
                              this.state.date_1 === "" ||
                              this.state.vehicleId === 0 ||
                              // !this.state.customAnticipatedCharge ||
                              // !this.validateDates() ||
                              (this.state.gpsDeviceId === 0 && this.state.r_gps && this.getModelName1() !== "K1600GT")
                            }
                            saving={isOnSubmit}
                          />
                        </Grid>
                        <Grid item>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="noConfirmationEmail"
                                checked={this.state.noConfirmationEmail}
                                onChange={e => this.handleCheckChange(e)}
                                value="noConfirmationEmail"
                              />
                            }
                            label="Don't send confirmation e-mail"
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </div>
                  <div style={styles.rightCol}>
                    <div style={styles.flex}>
                      <Card>
                        <CardContent>
                          <SimpleForm toolbar={null}>
                            <InputLabel shrink style={{ textAlign: "center" }}>
                              Choices & Prices
                            </InputLabel>
                            <FunctionField
                              label="Booking Date"
                              render={() => {
                                return moment.utc(
                                  rental.booking.r_timestamp
                                ).format(DATEFORMAT + " HH:mm:ss");
                              }}
                            />
                            {rental.from_agency && (
                              <FunctionField
                                label="Agency Name"
                                render={() => {
                                  return rental.booking.agency_name;
                                }}
                              />
                            )}
                            {rental.from_agency && (
                              <FunctionField
                                label="Agency Contact"
                                render={() => {
                                  return rental.booking.agency_contact;
                                }}
                              />
                            )}
                            <FunctionField
                              label="Pick-up"
                              render={() => {
                                let date1 = `${moment.utc(date_1).format(
                                  DATEFORMAT
                                )}`;
                                if (
                                  this.isHoliday(moment(date_1), hollidays1) ||
                                  this.isWeekEnd(date_1)
                                ) {
                                  return (
                                    <div>
                                      {date1}
                                      <span
                                        style={{
                                          color: "red",
                                          fontSize: "17px"
                                        }}
                                      >
                                        &nbsp;<b>!</b>
                                      </span>
                                    </div>
                                  );
                                }
                                return date1;
                              }}
                            />
                            <FunctionField
                              label="Drop-off"
                              render={() => {
                                let date2 = `${moment.utc(date_2).format(
                                  DATEFORMAT
                                )}`;
                                if (
                                  this.isHoliday(moment(date_2), hollidays2) ||
                                  this.isWeekEnd(date_1)
                                ) {
                                  return (
                                    <div>
                                      {date2}
                                      <span
                                        style={{
                                          color: "red",
                                          fontSize: "17px"
                                        }}
                                      >
                                        &nbsp;<b>!</b>
                                      </span>
                                    </div>
                                  );
                                }
                                return date2;
                              }}
                            />

                            <FunctionField
                              label="Rental Duration"
                              render={() => {
                                const daysLabel = this.state.isWeekendPromo
                                  ? `${rentalDays > 0 ? rentalDays : 0} days (2 billable)`
                                  : `${rentalDays > 0 ? rentalDays : 0} days`;
                                return (
                                  <span>
                                    {daysLabel}
                                    <RentalPromoBadges
                                      isWeekend={this.state.isWeekendPromo}
                                      lowSeasonPct={this.state.lowSeasonPct}
                                    />
                                  </span>
                                );
                              }}
                            />

                            <FunctionField
                              label="Gps"
                              render={() => {
                                const extras = this.state.occupancyDays != null
                                  ? this.state.occupancyDays
                                  : rentalDays;
                                const promo = buildRentalPromoSnapshot({
                                  date_1: this.state.date_1,
                                  time_1: this.state.time_1,
                                  date_2: this.state.date_2,
                                  time_2: this.state.time_2,
                                  from_agency: path(["from_agency"], this.state.rental),
                                });
                                const gpsTotal = applyLowSeasonDiscountFor(
                                  gpsPrice * extras,
                                  promo,
                                  "gps"
                                );
                                const gpsDaily =
                                  extras > 0
                                    ? Math.round((gpsTotal / extras) * 100) / 100
                                    : gpsPrice;
                                return `${gpsTotal} Euros (${gpsDaily} Euros/day)`;
                              }}
                            />

                            <FunctionField
                              label={`${insuranceLabel(this.state.r_insurance_id)} Insurance`}
                              render={() => {
                                const extras = this.state.occupancyDays != null
                                  ? this.state.occupancyDays
                                  : rentalDays;
                                return `${extras *
                                  vipInsurancePrice} Euros (${vipInsurancePrice} Euros/day)`;
                              }}
                            />

                            <FunctionField
                              label="One Way rental"
                              render={() => {
                                if (
                                  this.state.location_id_1 ===
                                  this.state.location_id_2
                                ) {
                                  return "No";
                                }
                                return `Yes (${locationFeePrice} Euros)`;
                              }}
                            />

                            <FunctionField
                              label="Rewards Used"
                              render={() => {
                                return `${rental.booking.rewards} points`;
                              }}
                            />
                            <FunctionField
                              label="First Choice Motorcycle"
                              render={() => {
                                return this.getModelName(
                                  rental.booking.vehicle_model_1
                                );
                              }}
                            />
                            <FunctionField
                              label="Second Choice Motorcycle"
                              render={() => {
                                return this.getModelName(
                                  rental.booking.vehicle_model_2
                                );
                              }}
                            />
                            <FunctionField
                              label="Daily rate for first choice motorcycle"
                              render={() => {
                                return `${model1Price} Euros/day`;
                              }}
                            />
                            <FunctionField
                              label="Daily rate for second choice motorcycle"
                              render={() => {
                                return `${model2Price} Euros/day`;
                              }}
                            />
                            <FunctionField
                              label="First choice of motorcycle"
                              style={styles.strong}
                              render={() => {
                                return `${rentalTotal1} Euros`;
                              }}
                            />
                            <FunctionField
                              label="Second choice of motorcycle"
                              render={() => {
                                return `${rentalTotal2} Euros`;
                              }}
                            />
                            <FunctionField
                              label="Comments"
                              render={() => {
                                return rental.booking.r_comments;
                              }}
                            />

                            <FunctionField
                              label="Client Passport"
                              render={() => {
                                const passport = rental.booking && Number(rental.booking.is_for) === 2
                                  ? rental.booking.r_passport
                                  : rental.driver.passport;
                                return `${isNil(passport) ? "N/A" : passport}`;
                              }}
                            />

                            <FunctionField
                              label="Driving Licence"
                              render={() => {
                                const licence = rental.booking && Number(rental.booking.is_for) === 2
                                  ? rental.booking.r_license
                                  : rental.driver.driving_licence;
                                return `${isNil(licence) ? "N/A" : licence}`;
                              }}
                            />

                            <FunctionField
                              label="Card Data"
                              render={() => {
                                return `${isNil(rental.clientData)
                                  ? "N/A"
                                  : rental.clientData
                                  }`;
                              }}
                            />
                          </SimpleForm>
                        </CardContent>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            }
          />
        </CardContent>
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  state: state
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit
};

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(ProcessRental)
);



// WEBPACK FOOTER //
// ./src/components/processRental.js